module.exports = __webpack_public_path__ + "static/media/bo.ba3aba41.svg";